var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.locoSectionParameters),function(parameter){return _c('Graph',{key:parameter[0].name,attrs:{"data":parameter,"parameterName":parameter[0].name}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }